import { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Grid,
  InputAdornment,
  IconButton,
  Divider,
} from "@mui/material";
import { FaSearch } from "react-icons/fa";

const getWeekStartAndEnd = (date) => {
  const d = new Date(date);
  const day = d.getDay();

  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  const monday = new Date(d.setDate(diff));
  monday.setHours(0, 0, 0, 0);

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  sunday.setHours(23, 59, 59, 999);

  return { weekStart: monday, weekEnd: sunday };
};

const formatDate = (date) => {
  const options = { month: "short", day: "numeric" };
  return date.toLocaleDateString("en-US", options);
};

const formatDateWithYear = (date) => {
  const options = { month: "short", day: "numeric", year: "numeric" };
  return date.toLocaleDateString("en-US", options);
};

const users = [
  { id: "1", name: "John Doe" },
  { id: "2", name: "Jane Smith" },
  { id: "3", name: "Robert Johnson" },
  { id: "4", name: "Emily Davis" },
  { id: "5", name: "Michael Wilson" },
];

const timeLogs = [
  {
    id: "1",
    userId: "1",
    date: "2025-03-10",
    projectName: "Project Alpha",
    scaffoldId: "S-001",
    startTime: "08:00",
    endTime: "16:30",
    breakTime: 30,
    totalHours: 8,
    workType: "Regular",
    additionalCompensation: "Dust Work Bonus",
    status: "Approved",
  },
  {
    id: "2",
    userId: "1",
    date: "2025-03-11",
    projectName: "Project Alpha",
    scaffoldId: "S-002",
    startTime: "08:00",
    endTime: "17:00",
    breakTime: 30,
    totalHours: 8.5,
    workType: "Overtime",
    additionalCompensation: null,
    status: "Pending",
  },
  {
    id: "3",
    userId: "2",
    date: "2025-03-10",
    projectName: "Project Beta",
    scaffoldId: "S-003",
    startTime: "09:00",
    endTime: "17:30",
    breakTime: 60,
    totalHours: 7.5,
    workType: "Regular",
    additionalCompensation: null,
    status: "Approved",
  },
  {
    id: "4",
    userId: "3",
    date: "2025-03-11",
    projectName: "Project Gamma",
    scaffoldId: "S-004",
    startTime: "22:00",
    endTime: "08:00",
    breakTime: 60,
    totalHours: 9,
    workType: "Night Shift",
    additionalCompensation: "Chemical Work Bonus",
    status: "Pending",
  },
  {
    id: "5",
    userId: "1",
    date: "2025-03-12",
    projectName: "Project Alpha",
    scaffoldId: "S-001",
    startTime: "08:00",
    endTime: "16:30",
    breakTime: 30,
    totalHours: 8,
    workType: "Regular",
    additionalCompensation: null,
    status: "Approved",
  },
  {
    id: "6",
    userId: "4",
    date: "2025-03-12",
    projectName: "Project Delta",
    scaffoldId: "S-005",
    startTime: "08:00",
    endTime: "16:00",
    breakTime: 30,
    totalHours: 7.5,
    workType: "Regular",
    additionalCompensation: null,
    status: "Pending",
  },
];

export default function AdminWeeklyOverview() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);

  const { weekStart, weekEnd } = getWeekStartAndEnd(currentDate);
  const weekRange = `${formatDate(weekStart)} - ${formatDateWithYear(weekEnd)}`;

  const goToPreviousWeek = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() - 7);
    setCurrentDate(newDate);
  };

  const goToNextWeek = () => {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() + 7);
    setCurrentDate(newDate);
  };

  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredLogs = timeLogs.filter((log) => {
    const logDate = new Date(log.date);
    const isInCurrentWeek = logDate >= weekStart && logDate <= weekEnd;

    if (!isInCurrentWeek) return false;
    if (selectedUser && log.userId !== selectedUser) return false;

    return true;
  });

  const exportWeeklyReport = () => {
    alert("Exporting weekly report...");
  };

  const SearchIcon = () => (
    <span
      style={{
        display: "inline-flex",
        width: 18,
        height: 18,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      🔍
    </span>
  );

  const ChevronLeftIcon = () => (
    <span
      style={{
        display: "inline-flex",
        width: 18,
        height: 18,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      ◀
    </span>
  );

  const ChevronRightIcon = () => (
    <span
      style={{
        display: "inline-flex",
        width: 18,
        height: 18,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      ▶
    </span>
  );

  const DownloadIcon = () => (
    <span
      style={{
        display: "inline-flex",
        width: 18,
        height: 18,
        alignItems: "center",
        justifyContent: "center",
        marginRight: 8,
      }}
    >
      ⬇️
    </span>
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={3}>
        <Card sx={{ height: "100%" }}>
          <CardHeader title="Users" titleTypographyProps={{ variant: "h6" }} />
          <Divider />
          <div style={{ position: "relative", width: "100%" }}>
            <input
              type="text"
              placeholder="Search users..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "100%",

                fontSize: "16px",

                borderRadius: "4px",
                outline: "none",
              }}
            />
            <FaSearch
              size={16}
              style={{
                position: "absolute",
                left: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#999",
              }}
            />
          </div>
          <CardContent
            sx={{ p: 2, maxHeight: "calc(100vh - 300px)", overflow: "auto" }}
          >
            <Button
              variant={selectedUser === null ? "contained" : "outlined"}
              fullWidth
              sx={{ justifyContent: "flex-start", mb: 1 }}
              onClick={() => setSelectedUser(null)}
            >
              All Users
            </Button>
            {filteredUsers?.map((user) => (
              <Button
                key={user.id}
                variant={selectedUser === user.id ? "contained" : "outlined"}
                fullWidth
                sx={{ justifyContent: "flex-start", mb: 1 }}
                onClick={() => setSelectedUser(user.id)}
              >
                {user.name}
              </Button>
            ))}
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={9}>
        <Card>
          <CardHeader
            title={
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "space-between",
                  alignItems: { xs: "flex-start", md: "center" },
                  gap: 2,
                }}
              >
                <Typography variant="h5">Weekly Time Log Overview</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <IconButton size="small" onClick={goToPreviousWeek}>
                    <ChevronLeftIcon />
                  </IconButton>
                  <Typography variant="body2" sx={{ fontWeight: "medium" }}>
                    {weekRange}
                  </Typography>
                  <IconButton size="small" onClick={goToNextWeek}>
                    <ChevronRightIcon />
                  </IconButton>
                  <Button
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                    onClick={exportWeeklyReport}
                    size="small"
                  >
                    Export Report
                  </Button>
                </Box>
              </Box>
            }
            disableTypography
          />
          <Divider />
          <CardContent>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Project</TableCell>
                    <TableCell>Scaffold ID</TableCell>
                    <TableCell>Start Time</TableCell>
                    <TableCell>End Time</TableCell>
                    <TableCell>Total Hours</TableCell>
                    <TableCell>Work Type</TableCell>
                    <TableCell>Compensation</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredLogs?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center" sx={{ py: 3 }}>
                        <Typography color="text.secondary">
                          No time logs found for this week.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredLogs?.map((log) => (
                      <TableRow key={log.id}>
                        <TableCell>{log.date}</TableCell>
                        <TableCell>{log.projectName}</TableCell>
                        <TableCell>{log.scaffoldId}</TableCell>
                        <TableCell>{log.startTime}</TableCell>
                        <TableCell>{log.endTime}</TableCell>
                        <TableCell>{log.totalHours}</TableCell>
                        <TableCell>{log.workType}</TableCell>
                        <TableCell>
                          {log.additionalCompensation || "None"}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={log.status}
                            color={
                              log.status === "Approved" ? "success" : "default"
                            }
                            size="small"
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {filteredLogs.length > 0 && (
              <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid item xs={12} md={4}>
                  <Card>
                    <CardContent>
                      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                        {filteredLogs
                          .reduce((sum, log) => sum + log.totalHours, 0)
                          .toFixed(1)}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Total Hours
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Card>
                    <CardContent>
                      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                        {filteredLogs
                          .filter((log) => log.workType === "Overtime")
                          .reduce((sum, log) => sum + log.totalHours, 0)
                          .toFixed(1)}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Overtime Hours
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Card>
                    <CardContent>
                      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                        {
                          filteredLogs.filter(
                            (log) => log.additionalCompensation
                          ).length
                        }
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Bonus Compensations
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
